import React, { useState } from "react";
import { Button, Form, Link } from "@storybook/components";
import { styled } from "@storybook/theming";
export const PATForm = ({ onSubmit }) => {
    const [token, setToken] = useState("");
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(token);
    };
    return (React.createElement(Rows, null,
        React.createElement(StyledForm, { onSubmit: handleSubmit },
            React.createElement(StyledInput, { value: token, placeholder: "Personal access token", onChange: ({ target }) => { var _a; return setToken((_a = target) === null || _a === void 0 ? void 0 : _a.value); } }),
            React.createElement(Button, { type: "submit", primary: true, small: true }, "Save")),
        React.createElement("div", null,
            "You can create personal access token using",
            " ",
            React.createElement(Link, { cancel: false, href: "https://app.zeplin.io/profile/developer", target: "_blank", rel: "noopener noreferrer" }, "Developer"),
            " ",
            "page in your Zeplin profile."),
        React.createElement(FillerRow, null),
        React.createElement("small", null,
            React.createElement("i", null, "* The token will be stored in your browser's local storage. You can later remove it using the log out button"))));
};
const Rows = styled.div `
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 22px;
    height: 100%;
`;
const StyledForm = styled(Form) `
    display: flex;
    flex-direction: row;
    gap: 15px;
`;
const StyledInput = styled(Form.Input) `
    flex: 1;
`;
const FillerRow = styled.div `
    flex: 1;
`;
